/// <reference path="module/index.d.ts" />
import { SimpleChange, Input, ViewChild, Component, ElementRef, OnInit } from '@angular/core';
import { WidgetComponent } from '../../../dashboards/components/widget-component/widget-component';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/application-store';
import { ConfirmationService } from 'primeng/api';
import { PropertyDetails } from '../../models/property-details';
import * as models from './models/address';
import { Router } from '@angular/router';

/**
 * This is a demo component to show a google map
 * Ideally we would use angular component library
 * https://angular-maps.com/
 * But there are reported issues with Angular 4.3
 * */
@Component({
  selector: 'mojo-property-map',
  templateUrl: './property-map-widget.component.html'
})
export class PropertyMapWidget extends WidgetComponent implements OnInit {
  @ViewChild('map', { static: true }) mapElement: ElementRef;
  map: google.maps.Map;

  @Input() propertyDetails: PropertyDetails;
  @Input() showMap: boolean;
  @Input() staticMode: boolean;
  constructor(
    protected readonly store: Store<ApplicationState>,
    protected readonly confirmations: ConfirmationService,
    private readonly router: Router
  ) {
    super(store, confirmations);
  }

  staticMap() {
    const mapProp = {};
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProp);

    const bounds = new google.maps.LatLngBounds();
    models.addressData.forEach(address => {
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(address.lat, address.lng),
        map: this.map,
        title: address.name
      });
      bounds.extend(marker.getPosition());
      marker.setClickable(true);
      marker.addListener('click', () => this.router.navigateByUrl(`/property/${address.ref}`));
    });    
    this.map.setCenter(bounds.getCenter());
    this.map.fitBounds(bounds);
    this.showMap = true;
  }


  propertyDetailsGeoCodeMap() {
    const geocoderRequest =
    {
      address: this.propertyDetails.Address,
      componentRestrictions: {
        country: 'GB',
      }
    };
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(geocoderRequest, (results: Array<google.maps.GeocoderResult>) => {

      if (results && results.length > 0) {
        const first = results[0];

        const mapProp = {
          center: new google.maps.LatLng(first.geometry.location.lat(), first.geometry.location.lng()),
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          gestureHandling: 'cooperative'
        };
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapProp);
        const propertyMarker = new google.maps.Marker({
          position: mapProp.center,
          title: this.propertyDetails.Name
        });
        propertyMarker.setMap(this.map);
        this.map.fitBounds(first.geometry.viewport);
        this.showMap = true;
      } else {
        this.showMap = false;
      }

    });
  }

  ngOnInit() {

    if (this.staticMode) {
      this.staticMap();
    } else {
      if (!this.propertyDetails || !this.propertyDetails.Address) {
        return;
      }
      this.propertyDetailsGeoCodeMap();
    }
  }
}
